import Swal from "sweetalert2";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Avatar, Divider, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { FaUser } from "react-icons/fa";
import { Logout, Settings } from "@mui/icons-material";
import Logo from '../../assets/images/Logo/Bharat-Darshan-Logo.png';
import * as Actions from '../../redux/actions/dashboardAction';

const Header = ({ dispatch }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [data, setData] = useState()

  useEffect(() => {
    try {
      const userData = localStorage.getItem("token");
      setData(userData)

      if (!userData) {
        navigate("/login");
      }
    }
    catch (e) {
      console.log(e)
    }
  }, [data]);

  const toggleSidebar = () => {
    dispatch(Actions.setIsSidebarOpne());
  };

  const logout = () => {
    Swal.fire({
      title: `Are you sure to Logout`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#164E62',
      cancelButtonColor: '#EDF2F5',
      confirmButtonText: "Logout",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          setData("");
          localStorage.clear();
        } catch (e) {
          console.log(e);
        }
      }
    });
    // try {
    //   localStorage.clear();
    //   setUserToggle(false)
    // } catch (e) {
    //   console.log(e);
    // }
  };

  useEffect(() => {
    let previousWidth = window.innerWidth;
    // console.log("Screen Width ::: ", previousWidth)
    const handleResize = () => {
      if (window.innerWidth > 900) {
        // console.log('Window is getting larger');
        dispatch(Actions.setIsSidebarOpne(true));
      } else if (window.innerWidth < 900) {
        dispatch(Actions.setIsSidebarOpne(false));
        // console.log('Window is getting smaller');
      }
    };

    // Set up event listener
    window.addEventListener('resize', handleResize);

    // Clean up event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <header style={{ backgroundColor: "#000", color: "#fff", position: "fixed", padding: "15px 40px", top: "20px", width: "97.5vw", alignSelf: "center", borderRadius: "20px", zIndex: "10" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
              <img src={Logo} style={{ width: 40, height: 40, cursor: "pointer", backgroundColor: "#fff" }} onClick={toggleSidebar} />
              <h3 style={{ color: "#fff", fontFamily: "philosopher", marginTop: "5px" }}>Bharat Darshan </h3>
            </div>

            <div style={{ backgroundColor: "#fff", borderRadius: "50%", padding: "5px" }}>
              <FaUser size={'25px'} onClick={handleClick} className="user_icon" />
            </div>
          </div>
        </header>
      </div>


      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleClose}>
          <Avatar /> Profile
        </MenuItem>
        <Divider />
        {/* <MenuItem onClick={() => navigate('/add-sub-admin')}>
          <ListItemIcon>
            <PersonAdd fontSize="small" />
          </ListItemIcon>
          Add sub-admin
        </MenuItem> */}
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};


const mapStateToProps = state => ({
  isSidebarOpen: state.dashboard.isSidebarOpen
})

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Header);

